exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-mono[data-v-55445bc6] {\n    font-family: monospace;\n}\n.border-primary-light[data-v-55445bc6] {\n    border-color: #cbd5e1 !important;\n}\n", ""]);

// exports
